import React, { CSSProperties, ReactNode } from 'react';
import styles from './contactComponent.module.scss';

type ContactBannerComponentProps = {
    children?: ReactNode;
    extraStyles?: CSSProperties;
    heading?: string;
    productType?: string;
    isReadyForDemo?: boolean;
    isPlural?: boolean;
};

const ContactBannerComponent = ({
    extraStyles,
    children,
    heading,
    productType,
    isReadyForDemo = true,
    isPlural = false,
}: ContactBannerComponentProps) => {
    const renderDescription = () => {
        if (isPlural) {
            return productType ? productType + 's' : 'solutions' + ' are';
        }

        return `${productType || 'solution'} is`;
    };

    return (
        <section>
            <div className={styles.contactBanner}>
                <img
                    src={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/images/backgrounds/contact-banner-bg.jpeg`}
                    alt="contact Noria"
                />
                {heading && <h2>{heading}</h2>}
                {isReadyForDemo && (
                    <p>
                        Don’t just take our word for it, see for yourself just how easy and
                        effective the {renderDescription()}
                    </p>
                )}
                <p>Our experts are standing by to help!</p>
                <div className={styles.contacts}>{children}</div>
            </div>
        </section>
    );
};

export default ContactBannerComponent;
